import React from 'react';
interface LogoProps {
  className?: string;
}
export function Logo({
  className = 'h-11 w-11'
}: LogoProps) {
  return <svg viewBox="0 0 48 48" role="img" aria-label="Cocarde FFPLUM" className={className} data-id="element-106" data-mp="8tv2v26xfsjr">
      <circle cx="24" cy="24" r="23" fill="#ffffff" stroke="#0a1b2e" strokeWidth="1.5" data-id="element-107" data-mp="3qambp22c3n3k" />
      <path d="M24 5a19 19 0 0 1 0 38Z" fill="#d8232a" data-id="element-108" data-mp="3v7wctez35n78" />
      <path d="M24 5a19 19 0 0 0 0 38Z" fill="#123a6b" data-id="element-109" data-mp="3v6bfjhldzq5o" />
      <rect x="21.4" y="12" width="5.2" height="24" rx="0.6" fill="#ffffff" data-id="element-110" data-mp="mu5ui7g29b5z" />
      <rect x="12" y="21.4" width="24" height="5.2" rx="0.6" fill="#ffffff" data-id="element-111" data-mp="rsh0u875d3jg" />
    </svg>;
}